import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";

export default function PopupChangeBg({
  open,
  onClose,
  imageWithoutBg,
  bgList,
  onChangeBg,
  onSave,
}) {
  const [selectedBg, setSelectedBg] = useState(
    bgList && bgList.length > 0 ? bgList[0] : null
  );
  const isPC = useMediaQuery("(min-width: 1024px)");

  React.useEffect(() => {
    if (bgList && bgList.length > 0) setSelectedBg(bgList[0]);
  }, [bgList]);

  const handleSelectBg = (bg) => {
    setSelectedBg(bg);
    if (onChangeBg) onChangeBg(bg);
  };

  const getBgUrl = (bg) => bg.url || bg.Url;

  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    //  width: "100%",
    minHeight: 300,
    padding: 10,
    boxSizing: "border-box",
    gap: 16,
  };
  const leftStyle = {
    flex: 1,
    minWidth: 250,
    minHeight: 250,
    maxWidth: 400,
    maxHeight: 400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    margin: "auto",
  };
  const previewBgStyle = {
    width: "100%",
    height: 0,
    paddingBottom: "100%",
    backgroundImage: selectedBg ? `url('${getBgUrl(selectedBg)}')` : undefined,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };
  const imageStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    objectFit: "contain",
    pointerEvents: "none",
  };
  const rightStyle = {
    backgroundColor: "#f5f5f5",
    flex: 1,
    //minWidth: isPC ? "0%" : 120,
    display: "flex",
    flexDirection: isPC ? "column" : "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 12,
    paddingLeft: 8,
    overflowY: "auto",
    maxHeight: 420,
  };
 const bgThumbStyle = (bg) => ({
    width: 70,
    height: 70,
    borderRadius: 8,
    border:
      selectedBg && selectedBg.id === bg.id
        ? "3px solid #1976d2"
        : "2px solid #ccc",
    backgroundImage: `url('${getBgUrl(bg)}')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    marginBottom: 8,
    boxShadow:
      selectedBg && selectedBg.id === bg.id ? "0 0 8px #1976d2" : "none",
    transition: "border 0.2s, box-shadow 0.2s",
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Changer le fond
        <IconButton aria-label="close" onClick={onClose} sx={{ ml: 2 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          {" "}
          <div style={previewBgStyle}>
            {imageWithoutBg && (
              <img src={imageWithoutBg} alt="Preview" style={imageStyle} />
            )}
          </div>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {bgList &&
              bgList.map((bg) => (
                <Grid item xs={3}>
                  <div
                    key={bg.id}
                    style={bgThumbStyle(bg)}
                    onClick={() => handleSelectBg(bg)}
                    title={`Background ${bg.id}`}
                  />
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>
      {/* Left: Preview */}

      {/* Right: List of backgrounds */}

      <div style={{ display: "flex", justifyContent: "center", padding: 16 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSave(selectedBg)}
        >
          Sauvegarder
        </Button>
      </div>
    </Dialog>
  );
}
